module.exports = __webpack_public_path__ + "static/img/telll.9319457.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/telll.png
// module id = +7eM
// module chunks = 0